import styled from "styled-components";

interface IContainer {
  width?: string;
}
export const Container = styled.div<IContainer>`
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 4rem 2.5rem;
  width: ${(props) => props.width};

  h1 {
    ${(props) => `
      color: ${props.theme.colors.blackTextTitle};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 0;
  }

  p {
    ${(props) => `
      color: ${
        props.theme.colors.blackTextTitle + props.theme.transparencies.p58
      };
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 2.4rem;
    margin-top: 2rem;
    padding: 0 1rem;
    text-align: center;
  }
`;

export const MainButton = styled.button`
  ${(props) => `
    background-color: ${props.theme.colors.primaryBlue};
    color: ${props.theme.colors.white};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}

  align-items: center;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  display: flex;
  font-size: 1.5em;
  font-weight: 700;
  justify-content: center;
  margin-top: 1rem;
  min-height: 5.6rem;
  width: 32.4rem;

  :disabled,
  [disabled] {
    background-color: ${(props) =>
      props.theme.colors.primaryBlue + props.theme.transparencies.p20};
  }
`;
